module.exports = __webpack_public_path__ + "static/img/medicalReport.bf291a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/theme/normal/img/medicalReport.png
// module id = abzr
// module chunks = 15